import type { SVGProps } from 'react';
const SvgIconTeam = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M13.25 0a.75.75 0 0 1 .75.75V2h1.25a.75.75 0 0 1 0 1.5H14v1.25a.75.75 0 0 1-1.5 0V3.5h-1.25a.75.75 0 0 1 0-1.5h1.25V.75a.75.75 0 0 1 .75-.75"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.75 2.75c0-.234.054-.456.15-.654A3.74 3.74 0 0 0 7.25 1h-.5A3.75 3.75 0 0 0 3 4.75v.5c0 .848.281 1.63.755 2.257A4 4 0 0 0 0 11.5v1A2.5 2.5 0 0 0 2.5 15h9a2.5 2.5 0 0 0 2.5-2.5v-1a4 4 0 0 0-3.755-3.993c.474-.628.755-1.41.755-2.257v-.5q0-.269-.037-.527A1.5 1.5 0 0 1 9.75 2.75M7.25 7.5A2.25 2.25 0 0 0 9.5 5.25v-.5A2.25 2.25 0 0 0 7.25 2.5h-.5A2.25 2.25 0 0 0 4.5 4.75v.5A2.25 2.25 0 0 0 6.75 7.5zM4 9a2.5 2.5 0 0 0-2.5 2.5v1a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-1A2.5 2.5 0 0 0 10 9z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconTeam;
